import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddPatientComponent } from './add-patient/add-patient.component';
import { AddingCaregiverComponent } from './adding-caregiver/adding-caregiver.component';
import { DailyTasksComponent } from './daily-tasks/daily-tasks.component';
import { HomeDeliveryComponent } from './medication-requests/home-delivery/home-delivery.component';
import { PickUpComponent } from './medication-requests/pick-up/pick-up.component';
import { RequestDetailsComponent } from './medication-requests/request-details/request-details.component';
import { SelectPharamcyComponent } from './medication-requests/select-pharamcy/select-pharamcy.component';
import { PendingCarereceiverComponent } from './pending-carereceiver/pending-carereceiver.component';
import { PendingPatientComponent } from './pending-patient/pending-patient.component';
import { PharmaciesComponent } from './pharmacies/pharmacies.component';
import { PharmacyDetailsComponent } from './pharmacy-details/pharmacy-details.component';
import { FinglodineSubscriptionsComponent } from './finglodine-subscriptions/finglodine-subscriptions.component';
import { PspPatientsComponent } from './psp-patients/psp-patients.component';
import { MyJourneyBeyondWeightComponent } from './my-journey-beyond-weight/my-journey-beyond-weight.component';
import { AddRochePatientComponent } from './add-roche-patient/add-roche-patient.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'daily-tasks', component: DailyTasksComponent },
      { path: 'pending-patient/:id', component: PendingPatientComponent },
      { path: 'pending-receiver/:id', component: PendingCarereceiverComponent },
      { path: 'add-caregiver', component: AddingCaregiverComponent },
      { path: 'add-patient', component: AddPatientComponent },
      {
        path: 'medication',
        children: [
          { path: 'home-delivery', component: HomeDeliveryComponent },
          { path: 'pick-up', component: PickUpComponent },
          { path: 'select-pharmacy', component: SelectPharamcyComponent },
          { path: 'request-details', component: RequestDetailsComponent },
        ],
      },
      { path: 'psp-pharmacy-details', component: PharmacyDetailsComponent },
      { path: 'pharmacies', component: PharmaciesComponent },
      {
        path: 'my-jounery-beyond-weight',
        component: MyJourneyBeyondWeightComponent,
      },
      {
        path: 'finglodine-subscriptions',
        component: FinglodineSubscriptionsComponent,
      },
      { path: 'psp-patients', component: PspPatientsComponent },
      { path: 'add-roche-patient/:id', component: AddRochePatientComponent },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PspRoutingModule {}
